import { render, staticRenderFns } from "./kaidan.vue?vue&type=template&id=5aee2457"
import script from "./kaidan.vue?vue&type=script&lang=js"
export * from "./kaidan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports